import textContent from 'utils/DOM/textContent'
import toggleClass from 'utils/DOM/toggleClass'

function handleAddonClasses({
  plans,
  hasDentalActive,
  dentalPlanId,
  visionPlanId,
  latitudeId,
  supplementalId
}) {
  const hasDental = Boolean(plans[dentalPlanId]) && !hasDentalActive
  const hasSupplemental = Boolean(plans[supplementalId])
  const hasLatitude = Boolean(plans[latitudeId])
  const hasVision = Boolean(plans[visionPlanId])

  const loading = document.body.classList.contains('show-loading')

  if (!loading) {
    toggleClass('body', 'has-dental', hasDental)
    toggleClass('body', 'has-vision', hasVision)
    toggleClass('body', 'has-latitude', hasLatitude)
    toggleClass('body', 'has-supplemental', hasSupplemental)
  }

  if (hasLatitude) {
    textContent('.js-latitude-title', plans[latitudeId].planName)
  }
}

export default handleAddonClasses
